import React from 'react';
import { Box, ButtonBase, Typography, Chip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import withShipment from '../../../withShipment';
import { viewOnlySelector } from '../../../redux/selectors/auth';

import { TOKENS } from '../theme';

// Reusable Manager Edit Mode toggle (spec §8). Same component used by
// Shift / Bonus / Raffle reports.
//
// This is the ONLY way into V2 manager edit mode on all three screens —
// `editMode` starts false and nothing else flips it — so removing the
// toggle at a VIEW-ONLY location closes the entire edit surface behind it
// (edit sheets, add, delete) in one place, with no per-screen work.
// Mirrors the existing `readOnly` prop ShiftDetail already uses for the
// Weekly Report audit log. See constants/readOnlyAccess.js.
function ManagerEditModeToggle({ on, onToggle, viewOnly }) {
  if (viewOnly) return null;

  const ringColor = on ? TOKENS.amber300 : TOKENS.slate200;
  const bg = on ? TOKENS.amber50 : '#fff';

  return (
    <ButtonBase
      onClick={onToggle}
      sx={{
        width: '100%',
        display: 'block',
        textAlign: 'left',
        borderRadius: 2,
        border: '1px solid',
        borderColor: ringColor,
        background: bg,
        p: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: on ? TOKENS.amber600 : TOKENS.slate100,
          }}
        >
          {on ? (
            <LockOpenIcon sx={{ color: '#fff', fontSize: 18 }} />
          ) : (
            <LockIcon sx={{ color: TOKENS.slate500, fontSize: 18 }} />
          )}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: on ? TOKENS.amber900 : TOKENS.slate900,
            }}
          >
            {on ? 'Manager Edit Mode · ON' : 'Manager Edit Mode'}
          </Typography>
          <Typography
            sx={{
              fontSize: 11,
              mt: 0.25,
              color: on ? TOKENS.amber700 : TOKENS.slate500,
            }}
          >
            {on
              ? 'Tap any entry to edit · Changes are logged'
              : 'Tap to enable editing'}
          </Typography>
        </Box>
        <Chip
          size="small"
          label={on ? 'ON' : 'OFF'}
          sx={{
            fontSize: 10,
            fontWeight: 700,
            background: on ? TOKENS.amber600 : TOKENS.slate200,
            color: on ? '#fff' : TOKENS.slate700,
            height: 22,
          }}
        />
      </Box>
    </ButtonBase>
  );
}

const mapStateToProps = (state) => ({
  viewOnly: viewOnlySelector(state),
});

export default withShipment(
  { mapStateToProps, actionCreators: {} },
  ManagerEditModeToggle
);
